import { render, staticRenderFns } from "./gohome.vue?vue&type=template&id=09638efe&scoped=true&"
import script from "./gohome.vue?vue&type=script&lang=js&"
export * from "./gohome.vue?vue&type=script&lang=js&"
import style0 from "./gohome.vue?vue&type=style&index=0&id=09638efe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09638efe",
  null
  
)

export default component.exports